import React, { useEffect, useState } from 'react'
import Sidebar from './Sidebar'
import { Box, Button, TextField } from '@mui/material'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useDispatch, useSelector } from 'react-redux';
import { getCategory } from '../Store/ActionCreators/CategoryActionCreator';
import { useNavigate } from 'react-router-dom';
import { addNotic } from '../Store/ActionCreators/NotifactionActionCreator';

export default function AddNotifaction() {
  const categoryList = useSelector((state)=>state.CategoryStateData)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [data, setData] = useState({
    category : '',
    titlename : '',
    content : ""
  })
  function getData(e){
    const name = e.target.name
    const value = e.target.value
    setData((old)=>{
      return{
        ...old,
        [name] : value
      }
    })
  }
  function postData(e){
    e.preventDefault()
    const item = {
      category : data.category,
      titlename : data.titlename,
      content:data.content
    }
    dispatch(addNotic(item))
    console.log(item)
    navigate("/notifaction")
  }
  useEffect(()=>{
    dispatch(getCategory())
  },[dispatch])
  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar />
      <Box className="boxStyle">
        <h4 className='bg-dark text-light p-1 text-center rounded mt-2' style={{
              fontFamily: "'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif"
            }}>Add Natifaction</h4>
        <div className="formSection">
          <h5>Notifaction Form</h5>
          <form className='mt-3' onSubmit={postData}>
            <div className="mb-3">
               <FormControl fullWidth>
                  <InputLabel id="select-subject">Select&nbsp;Subject</InputLabel>
                      <Select
                        labelId="select-subject"
                          id="demo-simple-select"
                          label="Select Subject"
                          name='category'
                          onChange={getData}
                          color='success'
                          variant='outlined' 
                      >
                        <MenuItem selected>Select Category</MenuItem>s
                          {
                            categoryList.map((cat, index) => (
                              <MenuItem value={cat.name} key={index}>{cat.name}</MenuItem>
                            ))
                          }                                      
                      </Select>
                </FormControl>
            </div>
            <div className="mb-3">
              <TextField placeholder='Enter Notifaction Header Name' name='titlename' variant='outlined' label="Notifaction Name" fullWidth color='success' onChange={getData}/>
            </div>
            <div className="mb-3">
              <TextField
                label="Full Notice Content (HTML Allowed)"
                multiline
                rows={10}
                fullWidth
                placeholder="Yahan full notice details likho ya HTML paste karo"
                value={data.content}
                onChange={(e) =>
                  setData({ ...data, content: e.target.value })
                }
              />
            </div>

            <div className="mb-3 mt-5">
              <Button type='submit' className='bg-dark text-light w-100 p-2'>Add Notifaction</Button>
            </div>
          </form>
        </div>
      </Box>
    </Box>
  )
}
